import { z } from "zod";

const PHONE_INPUT_INVALID_MESSAGE = "Use + at the start, then numbers only";

interface SanitizePhoneInputOptions {
  /** When false, strip to digits only (for inputs with a separate + prefix). */
  allowLeadingPlus?: boolean;
}

export function sanitizePhoneInput(
  raw: string,
  { allowLeadingPlus = true }: SanitizePhoneInputOptions = {},
): string {
  const compact = raw.replace(/\s/g, "");
  if (!compact) return "";

  if (!allowLeadingPlus) {
    return compact.replace(/\D/g, "");
  }

  let result = "";
  for (const char of compact) {
    if (char === "+" && result.length === 0) {
      result = "+";
      continue;
    }
    if (char >= "0" && char <= "9") {
      result += char;
    }
  }
  return result;
}

export function isAllowedPhoneInput(raw: string): boolean {
  const compact = raw.replace(/\s/g, "");
  if (!compact) return true;
  return /^\+?\d+$/.test(compact);
}

export function optionalPhoneInputSchema() {
  return z.string().superRefine((value, ctx) => {
    if (!isAllowedPhoneInput(value)) {
      ctx.addIssue({ code: "custom", message: PHONE_INPUT_INVALID_MESSAGE });
    }
  });
}

export function stripLeadingPlus(raw: string): string {
  return raw.replace(/^\+/, "");
}
